/* global process */
let base = window._env_.VUE_APP_ADMIN_HOST
export const getTaskOrderTable = params => {
  return axios.post(`${base}/task-order/query`, params)
}
export const exportTaskOrderData = params => {
  return axios.post(`${base}/task-order/export`, params)
}
export const getTaskOrderDetail = params => {
  return axios.get(`${base}/getTaskOrderDetail/${params.id}`, {params})
}
export const createTaskOrderData = params => {
  return axios.post(`${base}/createTaskOrderData`, params)
}
export const updateTaskOrderData = params => {
  return axios.post(`${base}/updateTaskOrderData/${params.id}`, params)
}
export const deleteTaskOrderData = params => {
  return axios.post(`${base}/deleteTaskOrderData/${params.id}`, params)
}
export const exportRecordRemark = params => {
  return axios.post(`${base}/batch_jobs/batch_export_record_remark`, params)
}



// WEBPACK FOOTER //
// ./src/views/task-order/task-order.api.js